import http from '@services/http'
import { IMessageList, IReadMessages, ISendMessage, IDeleteMessages, IReceiveItem, ICheckNick, IMessageOne, IMessageUpdate, IMessageOneForUser } from '@protocol/message'

export default {
  getMessageList(data: IMessageList.Params): Promise<IMessageList.Schema> {
    return http.post('message/messageList', data || {})
  },

  read(data: IReadMessages.Params): Promise<IReadMessages.Schema> {
    return http.post('message/read', data || {})
  },

  quickRead(data: IReadMessages.Params): Promise<IReadMessages.Schema> {
    return http.post('message/quickRead', data || {})
  },

  send(data: ISendMessage.Params): Promise<ISendMessage.Schema> {
    return http.post('message/send', data || {})
  },

  delete(data: IDeleteMessages.Params): Promise<IDeleteMessages.Schema> {
    return http.post('message/delete', data || {})
  },

  receive(data: IReceiveItem.Params): Promise<IReceiveItem.Schema> {
    return http.post('message/receive', data || {})
  },

  checkNick(data: ICheckNick.Params): Promise<ICheckNick.Schema> {
    return http.post('message/checkNick', data || {})
  },

  getOneUnReadClubMessageByClubId(data: IMessageOne.Params): Promise<IMessageOne.ResponseSchema> {
    return http.get('message/getOneUnReadClubMessageByClubId', data || {})
  },

  getOneUnQuickReadMessageByUserId(): Promise<IMessageOneForUser.ResponseSchema> {
    return http.get('message/getOneUnQuickReadMessageByUserId', {})
  },

  doConfirmReadClubMessageByClubIdAndId(data: IMessageUpdate.Params): Promise<IMessageUpdate.Schema> {
    return http.post('message/doConfirmReadClubMessageByClubIdAndId', data || {})
  },

}
